var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9012 14.106C17.0638 13.2679 16.0853 12.5839 15.0106 12.0853C16.5262 10.8574 17.4931 8.98394 17.4931 6.88294C17.4931 3.17608 14.4017 0.134981 10.6948 0.191856C7.0447 0.24873 4.1039 3.22292 4.1039 6.88294C4.1039 8.98394 5.07413 10.8574 6.58635 12.0853C5.51143 12.5835 4.53288 13.2676 3.69574 14.106C1.86903 15.936 0.831889 18.3515 0.764976 20.9275C0.764083 20.9632 0.770347 20.9988 0.783397 21.032C0.796447 21.0653 0.81602 21.0956 0.840963 21.1211C0.865906 21.1467 0.895715 21.167 0.928632 21.1809C0.961548 21.1947 0.996907 21.2019 1.03263 21.2019H2.90617C2.90773 21.2019 2.90929 21.2018 2.91085 21.2018H18.6928C18.6944 21.2018 18.6959 21.2019 18.6975 21.2019H20.571C20.6068 21.2019 20.6421 21.1947 20.675 21.1809C20.708 21.167 20.7378 21.1467 20.7627 21.1211C20.7876 21.0956 20.8072 21.0653 20.8203 21.032C20.8333 20.9988 20.8396 20.9632 20.8387 20.9275C20.7718 18.3515 19.7346 15.936 17.9012 14.106Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileNew);
export default __webpack_public_path__ + "static/media/profile_new.863573e3.svg";
export { ForwardRef as ReactComponent };